import { requests } from './baseServices'

export const PackageExpenseServices = {    
    getAll: (criteria) => requests.get('api/packageexpense', criteria),
    getAllWithOptions: (criteria) => requests.post('api/packageexpense/filtered', criteria),
    getById: (id) => requests.get(`api/packageexpense/${id}`),
    update: (id, template) => requests.put(`api/packageexpense/${id}`, template),
    create: (template) => requests.post(`api/packageexpense`, template),    
    delete: (id) => requests.delete(`api/packageexpense/${id}`),        
};